<template>
  <section class="app-main" style="min-height: 100%; margin: 20px;">
    <router-view :key="key"></router-view>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key () {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue